import { makeService } from './api';

const service = makeService('subscriptions');

export default service;